import type { AddressFormState } from "./addressForm";
import { expectedStateForCity, isCityValidForState, isValidIndianState } from "./indianLocationHierarchy";
import { isIndianStateName } from "./indianLocations";

export type AddressValidationResult =
  | { ok: true }
  | { ok: false; message: string };

export { isIndianStateName };

/** City must not be a state/UT name. */
export function isCityNameNotAState(city: string): boolean {
  const trimmed = city.trim();
  if (!trimmed) return false;
  return !isIndianStateName(trimmed);
}

export function validateAddressForm(form: AddressFormState): AddressValidationResult {
  const city = form.city.trim();
  const district = form.district.trim();
  const state = form.state.trim();
  const pincode = form.pincode.trim();

  if (!form.address_line1.trim()) {
    return { ok: false, message: "Enter address line 1." };
  }
  if (!state) {
    return { ok: false, message: "Select a state or union territory." };
  }
  if (!isValidIndianState(state)) {
    return { ok: false, message: "Select a valid Indian state or union territory." };
  }
  if (!district) {
    return { ok: false, message: "Select or enter a district." };
  }
  if (!city) {
    return { ok: false, message: "Enter or select a city." };
  }
  if (!isCityNameNotAState(city)) {
    return { ok: false, message: "City cannot be a state or union territory name. Choose a city." };
  }
  if (!/^\d{6}$/.test(pincode)) {
    return { ok: false, message: "Enter a valid 6-digit PIN code." };
  }
  if (!isCityValidForState(city, state)) {
    const expected = expectedStateForCity(city);
    if (expected) {
      return {
        ok: false,
        message: `"${city}" is usually in ${expected}, not ${state}. Update city or state.`,
      };
    }
    return { ok: false, message: `Check that "${city}" matches the selected state.` };
  }

  return { ok: true };
}
